import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormLabel,
  Heading,
  Input,
  InputGroup,
  InputRightAddon,
  Stack,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  Tag,
  Text,
  useMediaQuery,
  useSteps,
  Code,
  useToast,
} from "@chakra-ui/react";
import { ethers } from "ethers";
import { useEffect, useRef, useState } from "react";
import Blockies from "react-blockies";
import useMode from "../../hooks/useMode";
import useTokenBalance from "../../hooks/useTokenBalance";
import {
  approveToken,
  delegate,
  getdTokenBalance,
  ZERO_ADDRESS
} from "../../utils/contracts";
import { epochMode, modes } from "../../utils/constants";
import { useAccount } from "wagmi";

const DelegationDrawer = ({
  isOpen,
  onClose,
  operatorId,
  validatorAddress,
  toggleDrawer,
  signerAddressData,
}) => {
  const [amount, setAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [dTokenAmount, setdTokenAmount] = useState(0);
  const { address } = useAccount();
  const firstField = useRef();
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const steps = [
    { title: "Approve", description: "Approve tokens" },
    { title: "Delegate", description: "Delegate" },
  ];
  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: steps.length,
  });

  useEffect(() => {
    isOpen && address && fetchDelegatedAmount();
  }, [address, isOpen]);

  const fetchDelegatedAmount = async () => {
    if (signerAddressData?.dToken === ZERO_ADDRESS) return;
    const tokenBalance = await getdTokenBalance(
      signerAddressData?.dToken,
      address
    );
    setdTokenAmount(Number(tokenBalance));
  };
  const { balance } = useTokenBalance();
  const formattedBalance = ethers.utils.formatEther(balance);
  const { mode } = useMode();
  const toast = useToast();

  useEffect(() => {
    console.log(signerAddressData);
  }, [signerAddressData]);

  const onAmountChange = (e) => setAmount(e.target.value);

  const resetStep = () => {
    toggleDrawer();
    setActiveStep(0);
    setAmount(0);
  };

  const handleRPCError = (error) => {
    return <Code colorScheme="black">{error.message}</Code>;
  };

  const triggerToast = (title, status = "success", description = null) => {
    toast({
      title,
      description,
      status,
      isClosable: true,
      duration: 5000,
    });
  };

  const approveTokens = async () => {
    try {
      setIsLoading(true);
      console.log(amount);
      const { success, txHash, error } = await approveToken(amount);
      console.log({
        success,
        txHash,
      });
      setIsLoading(false);
      if (success) {
        setActiveStep(activeStep + 1);
        triggerToast("Approve transaction successful", "success", null);
      } else {
        triggerToast(
          "Approve transaction failed",
          "error",
          handleRPCError(error)
        );
      }
    } catch (error) {
      console.log("error in approving tokens");
      console.log(error);
    }
  };

  const delegateTokens = async () => {
    setIsLoading(true);
    console.log({ amount, operatorId });

    const { success, txHash, error } = await delegate(operatorId, amount);
    setIsLoading(false);
    console.log({
      success,
      txHash,
      error,
    });
    if (success) {
      triggerToast("Delegate transaction successful", "success", null);
      toggleDrawer();
      resetStep();
    } else {
      triggerToast(
        "Delegate transaction failed",
        "error",
        error?.message && handleRPCError(error)
      );
    }
  };

  const onClickHandler = async () => {
    switch (activeStep) {
      case 0:
        approveTokens();
        break;
      case 1:
        delegateTokens();
        break;
    }
  };

  const isDelegateMode = () => {
    if (
      mode === -1 ||
      mode === modes.Initialize ||
      mode === modes.operatorSelection
    ) {
      return false;
    }
    return true;
  };

  return (
    <>
      <Drawer
        isOpen={isOpen}
        initialFocusRef={firstField}
        onClose={onClose}
        placement={isMobile ? "bottom" : "right"}
      >
        <DrawerOverlay />
        <DrawerContent bg="linear-gradient(111.84deg, rgba(0, 0, 0, 0.94) 59.3%, rgba(26, 31, 55, 0) 100%)">
          <DrawerHeader borderBottomWidth="1px">
            <Tag>Delegation</Tag>
            <Flex>
              <Blockies seed={validatorAddress} className="indenticon" />
              <Text>{validatorAddress.slice(0, 20)}</Text>
            </Flex>
          </DrawerHeader>
          <DrawerBody>
            <Stack spacing="24px">
              <Box>
                <Stack
                  spacing="4"
                  direction="row"
                  justifyContent="space-between"
                >
                  <Box>
                    <Heading size="xs" textTransform="uppercase">
                      Balance
                    </Heading>
                    <Text pt="2" fontSize="sm">
                      {ethers.utils.formatEther(balance)}
                    </Text>
                  </Box>
                  <Box>
                    <Heading
                      size="xs"
                      textTransform="uppercase"
                      textAlign="end"
                    >
                      dToken Balance
                    </Heading>
                    <Text pt="2" fontSize="sm" textAlign="end">
                      {dTokenAmount.toFixed(5)}
                    </Text>
                  </Box>
                </Stack>
              </Box>
              <Box>
                <Stack
                  spacing="4"
                  direction="row"
                  justifyContent="space-between"
                >
                  <Box>
                    <Heading size="xs" textTransform="uppercase">
                      Commission
                    </Heading>
                    <Text pt="2" fontSize="sm">
                      10
                    </Text>
                  </Box>
                  <Box>
                    <Heading
                      size="xs"
                      textTransform="uppercase"
                      textAlign="end"
                    >
                      Mode
                    </Heading>
                    <Text pt="2" fontSize="sm" textAlign="end">
                      {mode === -1 ? "-" : epochMode[mode]}
                    </Text>
                  </Box>
                </Stack>
              </Box>
              <Box>
                <FormLabel htmlFor="amount">Delegation Amount</FormLabel>
                <InputGroup cursor="pointer">
                  <Input
                    type="number"
                    id="amount"
                    placeholder="Enter an amount"
                    onChange={onAmountChange}
                    disabled={activeStep == 1}
                    value={amount}
                  />
                  <InputRightAddon
                    onClick={() =>
                      activeStep == 0 && setAmount(formattedBalance)
                    }
                  >
                    MAX
                  </InputRightAddon>
                </InputGroup>
              </Box>
              <Box>
                <Stepper index={activeStep}>
                  {steps.map((step, index) => (
                    <Step key={index}>
                      <StepIndicator>
                        <StepStatus
                          complete={<StepIcon />}
                          incomplete={<StepNumber />}
                          active={<StepNumber />}
                        />
                      </StepIndicator>

                      <Box flexShrink="0">
                        <StepTitle fontSize="0.7rem">{step.title}</StepTitle>
                      </Box>

                      <StepSeparator />
                    </Step>
                  ))}
                </Stepper>
              </Box>
            </Stack>
            <Text fontSize="sm" color="red.400" pt="4">
              {!isDelegateMode() &&
                "Delegation is not allowed in Initialize and ValidatorSelection mode."}
            </Text>
          </DrawerBody>
          <DrawerFooter borderTopWidth="1px">
            <Button variant="outline" mr={3} onClick={() => resetStep()}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={onClickHandler}
              isLoading={isLoading}
              isDisabled={isLoading || !isDelegateMode() || amount <= 0}
            >
              {steps[activeStep]?.title ? steps[activeStep].title : "Approve"}
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default DelegationDrawer;
